import React, {useState} from "react";
import {Container, Row, Col, Collapse} from "react-bootstrap";

function FAQSection() {
  const [expandedQuestionOrder, setExpandedQuestionOrder] = useState(1);

  return (
    <section id="faq-section">
      <Container className="mt-5">
        <Row className="d-flex justify-content-center">
          <Col sm={12} className="text-center mb-2 mb-lg-4">
            {/*<h3 className="mb-3">FAQ</h3>*/}
            <h2>GOT QUESTIONS?</h2>
            <p>
              If you have any other questions - please get in touch at
              <span className="fw-bold"> info@fortinvestech.com</span>
            </p>
          </Col>
          <Col sm={12} lg={10} xl={8} className="mb-2 mb-lg-4">
            <div className="mt-4">
              <h4
                style={{
                  clear: "both",
                  borderBottomStyle: "groove",
                  paddingBottom: "20px",
                  borderWidth: "1px",
                }}
              >
                Is the service free? How do you earn?
                <i
                  className={`bi bi-arrow-${
                    expandedQuestionOrder === 1 ? "up" : "down"
                  }-circle button-expand`}
                  onClick={() =>
                    setExpandedQuestionOrder(
                      expandedQuestionOrder === 1 ? 0 : 1
                    )
                  }
                ></i>
              </h4>
              <Collapse in={expandedQuestionOrder === 1}>
                <div id="collapse-text">
                  <p style={{color: "#03001C99"}}>
                    Absolutely! Our service is completely free of charge.
                    Your Privacy and security are paramount to us, and we ensure that your data is never shared with
                    third parties. Our primary goal is to provide you with a seamless automation experience.<br/>
                    You can utilize our platform to follow your investment plan with ease and confidence. We are
                    committed to delivering outstanding value to our users. As you experience the benefits of our
                    service, we hope you will consider exploring our other plans, designed to cater to your evolving
                    needs.<br/>
                    Rest assured that our focus remains on empowering you to follow your investment decisions. So, feel
                    free to make the most of our service, and watch as the system helps you achieve your investment
                    goals with precision and efficiency.
                  </p>
                </div>
              </Collapse>
            </div>
            <div className="mt-4">
              <h4
                style={{
                  clear: "both",
                  borderBottomStyle: "groove",
                  paddingBottom: "20px",
                  borderWidth: "1px",
                }}
              >
                Why only specific brokers?
                <i
                  className={`bi bi-arrow-${
                    expandedQuestionOrder === 2 ? "up" : "down"
                  }-circle button-expand`}
                  onClick={() =>
                    setExpandedQuestionOrder(
                      expandedQuestionOrder === 2 ? 0 : 2
                    )
                  }
                ></i>
              </h4>
              <Collapse in={expandedQuestionOrder === 2}>
                <div id="collapse-text">
                  <p style={{color: "#03001C99"}}>
                    At Fort InvesTech, we understand that choosing the right broker is a crucial step in your investment
                    journey. Our commitment is to provide our users with a seamless and optimized trading experience. To
                    ensure the best possible service, we have implemented a rigorous internal screening process to
                    select the brokers we partner with.
                    <br/>
                    By carefully curating a list of reputable and reliable brokers, we can offer you a higher level of
                    service quality and support. Each broker that we endorse has been thoroughly assessed for factors
                    such as reliability, security, customer service, trading platform features, and competitive pricing.
                    <br/>
                    Currently, we recommend the following brokers based on their strong performance and positive user
                    feedback:
                  </p>
                  <br/>
                  <ul className="text-muted">
                    <li>
                      <strong>Interactive Brokers:</strong> Catering to investors in the USA, UK, EU, and beyond,
                      Interactive Brokers is renowned for its advanced tools and extensive market access. Read more: <a
                      href="" target="">Reasons to choose IBKR</a>
                    </li>
                    <br/>
                    <li>
                      <strong>Zerodha:</strong> A trusted name for investors in India, providing a feature-rich platform
                      for seamless investing experiences. Read more: <a href="" target="">Reasons to choose Zerodha</a>
                    </li>
                    {/*<li>*/}
                    {/*  All:{" "}*/}
                    {/*  <a href="" className="rest-of-the-world">*/}
                    {/*    Interactive Brokers*/}
                    {/*  </a>*/}
                    {/*</li>*/}
                  </ul>
                  <p style={{color: "#03001C99"}}>
                    We continuously review and update our list of partnered brokers to stay aligned with our commitment
                    to excellence. Rest assured that our selection process is designed to offer you the best
                    opportunities and ensure that your investment journey is in capable hands.
                    <br/>
                    If you have any questions about our broker selection or need further assistance in choosing the
                    right broker for your specific needs, our expert support team is here to guide you every step of the
                    way. We want you to embark on your investment journey with confidence and peace of mind.
                  </p>
                </div>
              </Collapse>
            </div>
            <div className="mt-4">
              <h4
                style={{
                  clear: "both",
                  borderBottomStyle: "groove",
                  paddingBottom: "20px",
                  borderWidth: "1px",
                }}
              >
                What happens if Fort Investech closes?
                <i
                  className={`bi bi-arrow-${
                    expandedQuestionOrder === 3 ? "up" : "down"
                  }-circle button-expand`}
                  onClick={() =>
                    setExpandedQuestionOrder(
                      expandedQuestionOrder === 3 ? 0 : 3
                    )
                  }
                ></i>
              </h4>
              <Collapse in={expandedQuestionOrder === 3}>
                <div id="collapse-text">
                  <p style={{color: "#03001C99"}}>
                    If Fort InvesTech were to close, rest assured that your investments and funds are entirely safe and
                    secure.
                    Your investments are held in your personal brokerage account, not with Fort InvesTech. Therefore,
                    even if our company were to cease operations, your assets would remain unaffected and protected
                    under your own name.
                  </p>
                  <p style={{color: "#03001C99"}}>
                    Here's what happens in the event of such a scenario:
                  </p>
                  <ul className="text-muted">
                    <li><strong>Investments with the Broker:</strong>
                      Your investments are held directly with the broker
                      firm i.e.
                      Interactive Brokers, Zerodha or similar. Fort InvesTech does not have access to or
                      control over these assets. They will continue to be held in your brokerage account as usual.
                    </li>
                    <li><strong>Money Transfers:</strong>
                      Any money in your brokerage account can only be transferred to
                      your own linked bank account. Fort InvesTech does not have the authority to withdraw or transfer
                      your funds to any other destination.
                    </li>
                    <li><strong>Fort InvesTech Account:</strong>
                      Deposits can only be made from your linked bank account to the brokerage account, and withdrawals
                      are only processed to your verified bank account. Fort InvesTech cannot handle these transactions
                      on your behalf.
                    </li>
                  </ul>
                  <p style={{color: "#03001C99"}}>
                    By ensuring that your investments are always held with reputable and regulated brokers, we
                    prioritize the security and protection of your assets. Our commitment to safeguarding your financial
                    interests remains unwavering, even in unforeseen circumstances.
                  </p>
                  <br/>
                  <p style={{color: "#03001C99"}}>
                    If you have any additional concerns or queries about the security of your investments, please don't
                    hesitate to reach out to our support team. We are here to address any questions you may have and
                    provide the necessary reassurance for a seamless investment experience.
                  </p>
                </div>
              </Collapse>
            </div>
            <div className="mt-4">
              <h4
                style={{
                  clear: "both",
                  borderBottomStyle: "groove",
                  paddingBottom: "20px",
                  borderWidth: "1px",
                }}
              >
                Which markets can you invest in using our service?
                <i
                  className={`bi bi-arrow-${
                    expandedQuestionOrder === 4 ? "up" : "down"
                  }-circle button-expand`}
                  onClick={() =>
                    setExpandedQuestionOrder(
                      expandedQuestionOrder === 4 ? 0 : 4
                    )
                  }
                ></i>
              </h4>
              <Collapse in={expandedQuestionOrder === 4}>
                <div id="collapse-text">
                  <p style={{color: "#03001C99"}}>
                    With Servus, we offer access to a diverse range of capital markets, allowing you to tailor your
                    investments to be tax-optimal based on your tax status, legal residency, and other relevant factors.
                    Our platform is designed to provide you with the flexibility to invest in multiple markets,
                    ensuring you can make informed decisions that align with your specific financial situation.
                  </p>
                  <p style={{color: "#03001C99"}}>
                    Currently, some of the key markets and instruments available for investment using Servus include:
                  </p>
                  <ol className="text-muted">
                    <li>
                      <strong>United States (US):</strong>
                      <ul>
                        <li><strong>Stocks: </strong>
                          Invest in individual stocks of prominent US companies listed on major stock exchanges.
                        </li>
                        <li>
                          <strong>ETFs: </strong>
                          ETFs (Exchange-Traded Funds): Diversify your portfolio with ETFs that track various market
                          indices or specific sectors.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>India:</strong>
                      <ul>
                        <li><strong>Stocks: </strong>
                          Invest in individual company stocks of one of the fastest growing economies in the world.
                        </li>
                        <li>
                          <strong>ETFs: </strong>
                          Diversify across Indian assets with ETFs that represent a basket of securities.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>United Kingdom (UK) / European Union (EU):</strong>
                      <ul>
                        <li>
                          <strong>ETFs: </strong>
                          Explore ETF options listed on UK/EU exchanges, providing exposure to various asset classes.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </Collapse>
            </div>
            <div className="mt-4">
              <h4
                style={{
                  clear: "both",
                  borderBottomStyle: "groove",
                  paddingBottom: "20px",
                  borderWidth: "1px",
                }}
              >
                Can I add multiple broker accounts?
                <i
                  className={`bi bi-arrow-${
                    expandedQuestionOrder === 5 ? "up" : "down"
                  }-circle button-expand`}
                  onClick={() =>
                    setExpandedQuestionOrder(
                      expandedQuestionOrder === 5 ? 0 : 5
                    )
                  }
                ></i>
              </h4>
              <Collapse in={expandedQuestionOrder === 5}>
                <div id="collapse-text">
                  <p style={{color: "#03001C99"}}>
                    Certainly! With Servus, you can easily add and manage multiple broker accounts. Customize your
                    investment instructions for each account, and our system will monitor and execute your plan. Sit
                    back and let Servus do the work for you, keeping your investments on track and optimized. Simplify
                    your investment management with Servus today!

                  </p>
                </div>
              </Collapse>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default FAQSection;
